import React, {Component} from 'react';
const { Link } = require('react-router');

import ProfileLink from '../ProfileLink';

import 'sass/headers/header.scss';

import {t, dt} from 'l10n';

class HeaderVirtualGifts extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        let {user} = this.props;

        return (
            <header className="virtualgift">
                <div className="content">
                    <h1>{t('Give a virtual gift to %1', user.nick)}</h1>
                    <div className="text-virtualgift">
                        <ProfileLink user={user}>{t('Back to profile of %1', user.nick)}</ProfileLink>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderVirtualGifts;


// WEBPACK FOOTER //
// ./src/components/virtualgift/HeaderVirtualGifts.js